var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIconNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "account_balance"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2481_6589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2481_6589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_balance_2",
    d: "M6.5 16.9999V8.99986H7.5V16.9999H6.5ZM11.5 16.9999V8.99986H12.5V16.9999H11.5ZM3.53845 19.9999V18.9999H20.4616V19.9999H3.53845ZM16.5 16.9999V8.99986H17.5V16.9999H16.5ZM3.53845 6.99986V6.15371L12 2.11523L20.4616 6.15371V6.99986H3.53845ZM6.18078 5.99986H17.8192L12 3.24986L6.18078 5.99986Z",
    fill: "#A3A3A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIconNeutral);
export default __webpack_public_path__ + "static/media/bank-icon-neutral.9fa51efa0f15240fa362eefb27a9c77a.svg";
export { ForwardRef as ReactComponent };